import { useTranslation } from "react-i18next";
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
// import '../../styles/components/_forms.scss'

export const Supplier = ({ dto, }) => {
  const { t } = useTranslation();
  return (
      <Box sx={{ mb: 2 }}>
          <Grid container spacing={2}>
              <Grid size={{ xs: 12, sm: 6 }}>
                  <TextField fullWidth required disabled size="small" label={t('commonFields.nit')} name="id_company_supplier" value={dto.id_company_supplier || ''} />
            </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                  <TextField fullWidth required disabled size="small" label={t('commonFields.businessName')} name="supplier" value={dto?.company_supplier_name || ''} />
              </Grid>
          </Grid>
      </Box>
  )
}
